export default {
    // button: {
    //   confirm: '确认',
    //   login: '登录'
    // }
    created: '创建',
    chat: '对话',
    home: '首页',
    paint: '绘画',
    template: '模板',
    square: '广场',
    MostPopular: '最受欢迎',
    RecentlyReleased: '最近发布',
    Author: '作者：',
    LightApp: '轻量应用',
    ApplicationOfKnowledge: '知识应用',
    Agent: '智能体',
    WorkFlow: '工作流',
    LoadMore: '加载更多',
    Collection: '收藏',
    All: '全部',
    PleaseEnterTheSearchContent: '请输入搜索内容',
    SignInSuccess: '签到成功，恭喜你获得{count}积分',
    SignIn: '签到',
    CheckSuccessful: '签到成功，恭喜你获得 ',
    Points: '积分.',
    YouHaveSignedInToday: '今日已签到，请明日再来！',
    ExitConfirmation: '退出将清空所有聊天记录，是否确认退出?',
    LogOut: '退出账户',
    ConfirmExit: '确定退出',
    Cancel: '取消',
    ExitSuccessful: '退出成功',
    CancelExit: '取消退出',
    PleaseEnterTheInvitationCode: '请填写邀请码',
    SuccessfullyReceived: '领取成功',
    RightsClaim: '权益领取',
    Nickname: '昵称：',
    Account: '我的账户',
    ClaimCode: '领取',
    Confirm: '确定',
    Help: '帮助',
    Version: '版本',
    MyAccount: '我的账户',
    DailySignIn: '每日签到',
    Documentation: '文档',
    OfficialWebsite: '官网',
    LogLOut: '退出登录',
    Login: '登录',
    LogIn: '登录',
    PageNotFound: '您的页面已经走失了',
    ViewDocumentation: '查看文档',
    BackToHome: '回到首页',
    Management: '管理',
    PleaseEnterYourKey: '请输入你的Key',
    ClickToApply: '点击申请',
    ApiKey: ' 的API Key',
    SaveSuccessful: '保存成功',
    ShareApplication: '分享应用',
    ApplicationLink: '应用链接:',
    CopyLink: '复制链接',
    IntegrateSystem: '同时你还可以通过对话API将该应用接入到你的系统中',
    OpenAPI: '开放API',
    WebEmbed: 'web嵌入',
    WeChatOfficial: '微信公众号',
    WeChatWork: '企业微信',
    WeChatService: '微信客服',
    QuickAccess: '快速接入',
    CopySuccessful: '复制成功',
    WeChat: '微信',
    FeiShu: '飞书',
    DingTalk: '钉钉',
    Add: '添加',
    PleaseEnterContent: '请输入内容',
    AddAll: '添加全部',
    PleaseEnterTriggerPrefix: '请输入触发前缀',
    SelectVariable: '选择引用的变量',
    NoOptions: '暂无选项',
    ThisVariableDoesNotExist: '此变量不存在',
    RegisterSuccess: '注册成功',
    BindPhoneSuccess: '绑定手机号成功',
    ModifyPasswordSuccess: '密码修改成功',
    BindOfficialAccountSuccess: '绑定公众号成功',
    LoginSuccess: '登录成功',
    PleaseEnterPhoneNumber: '请输入手机号',
    PleaseEnterPassword: '请输入密码',
    PleaseEnterNewPassword: '请输入新密码',
    PleaseEnterVerificationCode: '请输入验证码',
    GetVerificationCode: '获取验证码',
    WeChatLogin: '微信登录',
    PhoneLogin: '手机号登录',
    ContactUs: '联系我们',
    salesEmailDes: '请通过邮箱（{email}）联系我们，描述你的问题或需求，我们将在48小时内回复。',
    Register: '注册',
    Continue: '注册',
    Password: '密码',
    VerificationCode: '验证码',
    PhoneNumber: '手机号',
    NoAccount: '没有账号?',
    RegisterNow: '立即注册',
    ForgotPassword: '忘记密码',
    BindPhoneNumber: '绑定电话号码',
    ModifyPassword: '修改密码',
    Complete: '完成',
    Skip: '立即跳过',

    ScanQRCodeToLogin: '微信扫码关注公众号快速登录',
    LongPressQRCodeToLogin: '长按识别二维码快速登录',
    SwipeLeftAfterFollowing: '关注公众号后左滑可回到页面',
    ScanQRCodeToFollowOfficialAccount: '微信扫码关注，公众号中也能用哦~',
    AlreadyHaveAccount: '已有账号?',
    LoginNow: '立即登录',
    BindSuccess: '绑定成功',
    ScanSuccess: '扫码成功',
    Agree: '同意',
    Disagree: '不同意',
    UserAgreement: '使用协议',
    PrivacyPolicy: '隐私政策',
    ServiceAgreementAndPrivacy: '服务协议及隐私保护',
    HaveReadAndAgree: '已阅读并同意以下协议：',
    WeChatLoginTip: '已通过微信登录过的用户无需注册，在"我的账户"绑定手机号即可',
    BindPhoneNumberTip: '已使用微信扫码登录过的用户无需再次注册，可在「我的账户」页绑定手机号',
    InputPlaceholders: {
        phoneNumber: '请输入手机号',
        password: '请输入密码',
        newPassword: '请输入新密码',
        verificationCode: '请输入验证码',
        verificationyCode: '请输入验证码',
        SetLoginPassword: '设置登录密码',
    },
    And: '和',
    Submit: '提交',
    Bind: '绑定',
    ModifySuccess: '修改成功',
    AlreadyHaveAccountSkip: '已有账号?',
    GetVerificationCodeText: '获取验证码',
    ScanQRCodeToFollowOfficialAccountTip: '微信扫码关注，公众号中也能用哦~',
    FromLocalStorage: {
        privacyPolicy: 'privacyPolicy'
    },
    CongratulationsPasswordModified: '恭喜您，密码修改成功',
    CongratulationsOfficialAccountBound: '恭喜您，绑定公众号成功',
    LocalStorageKeys: {
        shareCode: 'shareCode',
        source: 'source',
        sourceDetail: 'sourceDetail',
        shareId: 'shareId'
    },
    CurrentVersion: '当前版本',
    ValidityPeriod: '有效期',
    ApplicationCount: '应用数量',
    WorkflowCount: '工作流数量',
    KnowledgeBaseCapacity: '知识库文件容量',
    KnowledgeBaseEntries: '知识库条数',
    DatabaseTotalRows: '内置数据库总行数',
    CustomPluginCount: '自定义插件数量',
    ClientCount: '客户端数量',
    TeamMemberCount: '团队成员数量',
    EnterpriseMemberCount: '企业成员数量',
    UpgradeVersion: '升级版本',
    Basic: '基础版',
    Standard: '标准版',
    Professional: '专业版',
    Enterprise: '企业版',
    Custom: '定制版',
    ExceededLimitTip: {
        app: '应用数量已超限，为避免无法正常使用，请升级版本或手动清理',
        workflow: '工作流数量已超限，为避免无法正常使用，请升级版本或手动清理',
        knowledgeBase: '知识库文件容量已超限，为避免无法正常使用，请升级版本或手动清理',
        knowledgeEntries: '知识库条数已超限，为避免无法正常使用，请升级版本或手动清理',
        database: '内置数据库总行数已超限，为避免无法正常使用，请升级版本或手动清理',
        customPlugin: '自定义插件数量已超限，为避免无法正常使用，请升级版本或手动清理',
        client: '当前客户端容量不足，为避免无法正常使用，请升级版本',
        team: '当前{type}空间容量不足，为避免无法正常使用，请升级版本'
    },
    Unit: {
        items: '个',
        persons: '人',
        rows: '行'
    },
    IKnow: '我知道了',
    Announcement: '公告',
    AnnouncementCenter: '公告中心',
    MarkAllAsRead: '一键已读',
    NoNotifications: '暂无通知',
    Back: '返回',
    ScrollMouseToZoom: '滚动鼠标放大缩小',
    PinchToZoom: '双指滑动放大缩小',
    ImageUploadOnlySupportFormat: '图片上传只支持 jpeg,png 格式',
    ImageSizeLessThan5MB: '图片大小需小于 5MB!',
    NoPermission: '暂无权限',
    // 主菜单
    Create: '创造',  // 创造
    Access: '接入',  // 接入
    Manage: '管理',  // 管理
    Discover: '发现', // 发现

    // Create 子菜单
    Apps: '应用',  // 应用
    Knowledge: '知识库',  // 知识库
    Database: '数据库', // 数据库
    Plugins: '插件',  // 插件
    Workflow: '工作流', // 工作流

    // Access 子菜单
    APIAccess: '应用接入', // 应用接入
    Client: '客户端',  // 客户端
    Customers: '客户管理', // 客户管理
    Chat: '对话管理',  // 对话管理

    // Manage 子菜单

    Dashboard: '数据看板', // 数据看板
    Team: '团队空间',  // 团队空间

    // Discover 子菜单
    Templates: '模板中心', // 模板中心
    Store: '应用广场', // 应用广场

    // 版本标签

    Pro: 'Pro',  // 专业版
    EmailLogin: {
        email: '邮箱',
        pleaseEnterEmail: '请输入邮箱',
    },
    ByContinuing: '继续登录则代表你已同意LinkAI',
    TermsOfService: '用户协议',
    WelcomeLinkAi: '欢迎使用LinkAI',
    AlreadyRememberedYourPassword: '已经想起密码?',
    PleaseCompleteSecurityVerification: '请完成安全验证',
    VerificationSuccess: '验证成功',
    VerificationFailed: '验证失败',
    SlideToCompleteVerification: '向右滑动完成验证',
    SearchAgent: '搜索智能体',
    SearchTemplate: '搜索模板',
    Search: '搜索',
    Console: '控制台',
    Docs: '文档',
    Portal: '官网',
    Notifications: '通知',
    CreateAgent: '创建应用',
    CongratulationsOnGetting: '恭喜您获得',
    Credits: '积分',
    CheckIn: '签到',
    YouHaveCheckedInTodayPleaseComeAgainTomorrow: '今日已签到，请明日再来！',
    LogOutAccount: '退出账户',
    AreYouSureYouWantToLogOut: '退出将清空所有聊天记录，是否确认退出?',
    HoldToSpeak: '长按说话',
    Speaking: '对话中',
    Thinking: '思考中',
    ClickToCancelReply: '点击取消回复',
    NetworkErrorPleaseRetry: '网络异常，请重试',
    PleaseAllowThePageToUseTheMicrophone: '请先允许该网页使用麦克风',
    NoVoicePermission: '当前没有语音权限',
    goToDocumentCenter: '前往文档中心',
    goToUpgrade: '前往升级',
    functionIntroduction: '功能简介',
}
